'use client';

import { useModalConfirmStore } from '@/stores/useModalConfirmStore';
import ModalConfirm from '@/components/modal/ModalConfirm';

export default function ModalConfirmWrapper() {
    const { isOpen, currentConfirm, closeModalConfirm } = useModalConfirmStore();

    return (
        <ModalConfirm
            isOpen={isOpen}
            onClose={closeModalConfirm}
            message={currentConfirm?.message ?? ''}
            subMessage={currentConfirm?.subMessage}
            confirmLabel={currentConfirm?.confirmLabel}
            cancelLabel={currentConfirm?.cancelLabel}
            onConfirm={currentConfirm?.onConfirm ?? (() => {})}
            onCancel={currentConfirm?.onCancel}
            variant={currentConfirm?.variant}
        />
    );
}
